import { useEffect, useState } from 'react'
import { getConversationLawStatus } from '@/agent-v2/conversations/fetch/get-conversation-law-status'
import { isValidUuid } from '@/util/is-valid-uuid'

/** Check on chat open and after a run finishes, independently of loaded history pages. */
export function useConversationLawStatus(conversationId: string, isRunning: boolean): boolean | null {
  const [result, setResult] = useState<{ conversationId: string; status: boolean | null } | null>(null)

  useEffect(() => {
    if (isRunning || !isValidUuid(conversationId)) return
    const controller = new AbortController()
    getConversationLawStatus(conversationId, controller.signal)
      .then((response) => {
        if (!controller.signal.aborted) setResult({ conversationId, status: response.has_stale_law })
      })
      .catch(() => {
        if (!controller.signal.aborted) setResult({ conversationId, status: null })
      })
    return () => controller.abort()
  }, [conversationId, isRunning])

  return result?.conversationId === conversationId ? result.status : null
}
